

class KeyboardDriver {
  constructor(options) {
    this.container = document;
    this.shortcuts = options.shortcuts;
    this.ee = options.ee;

    this.setupListeners();
  }

  setupListeners() {
    this.container.addEventListener('keydown', (e) => {
      const key = e.keyCode || e.which;
      if (key === 40) // ArrowDown
        this.ee.emit('hu-lb-key-arrowdown');
    });

    this.container.addEventListener('keypress', (e) => {
      const char = String.fromCharCode(e.keyCode || e.which || null);
      if ((/[a-zA-Z0-9]/).test(char))
        this.ee.emit('hu-lb-text-focus', char);
    });
  }
}

export default KeyboardDriver;


// WEBPACK FOOTER //
// ./app/js/components/keyboard-driver/KeyboardDriver.js